import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Get theme from localStorage or default to light
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('preferredTheme');
    return savedTheme ? JSON.parse(savedTheme) : false; // Default to light theme
  });

  useEffect(() => {
    // Save theme to localStorage whenever it changes
    localStorage.setItem('preferredTheme', JSON.stringify(isDark));
    // Apply theme to document
    document.body.className = isDark ? 'dark-theme' : 'light-theme';
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  const value = {
    isDark,
    toggleTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};